import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '海南华德科技有限公司（简称“华德科技”）',
            description: '海南华德科技有限公司（简称“华德科技”）总部位于海口，注册资金 1000 万元，拥有 50+ 项软件著作权，是国家级高新技术企业、国家科技型中小企业、海南省高新技术种子企业与海南省创新型中小企业。我们专注医疗健康、电子政务、数字企业三大领域，致力成为国内一流的软件服务商。',
            keywords: '海南华德科技有限公司,行业数字化解决方案,互联网医院,智慧就医,医疗设备全生命周期管理,电子政务信息化,数字企业,自主软件产品'
          }
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '海南华德科技有限公司（简称“华德科技”）',
            description: '海南华德科技有限公司（简称“华德科技”）总部位于海口，注册资金 1000 万元，拥有 50+ 项软件著作权，是国家级高新技术企业、国家科技型中小企业、海南省高新技术种子企业与海南省创新型中小企业。我们专注医疗健康、电子政务、数字企业三大领域，致力成为国内一流的软件服务商。',
            keywords: '海南华德科技有限公司,行业数字化解决方案,互联网医院,智慧就医,医疗设备全生命周期管理,电子政务信息化,数字企业,自主软件产品'
          }
        }, {
          path: '/home2',
          name: 'home2',
          component: resolve => require(['@/view/HomePage2'], resolve),
          meta: {
            title: '海南华德科技有限公司_医疗健康_电子政务_数字企业信息化',
            description: '海南华德科技有限公司（简称“华德科技”）总部位于海口，注册资金 1000 万元，拥有 50+ 项软件著作权，是国家级高新技术企业、国家科技型中小企业、海南省高新技术种子企业与海南省创新型中小企业。我们专注医疗健康、电子政务、数字企业三大领域，致力成为国内一流的软件服务商。',
            keywords: '海南华德科技有限公司,行业数字化解决方案,互联网医院,智慧就医,医疗设备全生命周期管理,电子政务信息化,数字企业,自主软件产品'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品',
            description: '海南华德科技有限公司软件产品：智能导诊、互联网医院、就医服务等医疗软件矩阵。',
            keywords: '医疗设备管理,医疗设备运营,互联网医院,就医服务，智能导诊'
          },
          children: [
            {
              path: '/software',
              // 原为 '/software/software'，该子路由并不存在，会被 path:'*' 兜底回首页，
              // 导致点击一级导航「产品与解决方案」无响应。改为指向首个子路由。
              redirect: '/software/software1'
            },
            {
              path: '/software/software1',
              name: 'software',
              component: resolve => require(['@/view/software1'], resolve),
              meta: {
                title: '软件产品丨智能导诊',
                description: '海南华德科技有限公司智能导诊：面向医疗机构的软件产品。',
                keywords: '智能导诊,互联网医院,智慧医疗'
              }
            },
            {
              path: '/software/software2',
              name: 'software',
              component: resolve => require(['@/view/software2'], resolve),
              meta: {
                title: '软件产品丨智慧医院便民服务系统',
                description: '海南华德科技有限公司医院自助服务管理系统：面向医疗机构的软件产品。',
                keywords: '医院自助服务,互联网医院,自助就医'
              }
            },
            {
              path: '/software/software3',
              name: 'software',
              component: resolve => require(['@/view/software3'], resolve),
              meta: {
                title: '软件产品丨智慧医院医护管理系统',
                description: '海南华德科技有限公司一站式便民服务平台：面向医疗机构的软件产品。',
                keywords: '一站式便民服务,互联网医院,智慧就医'
              }
            },
            {
              path: '/software/software4',
              name: 'software',
              component: resolve => require(['@/view/software4'], resolve),
              meta: {
                title: '软件产品丨智慧医院在线问诊系统',
                description: '海南华德科技有限公司互联网医院：面向医疗机构的软件产品。',
                keywords: '互联网医院,在线问诊,智慧医疗'
              }
            },
            {
              path: '/software/software5',
              name: 'software',
              component: resolve => require(['@/view/software5'], resolve),
              meta: {
                title: '软件产品丨智慧医院健康管理系统',
                description: '海南华德科技有限公司医院智能随访系统：面向医疗机构的软件产品。',
                keywords: '医院智能随访,互联网医院,健康管理'
              }
            },
            {
              path: '/software/software6',
              name: 'software',
              component: resolve => require(['@/view/software6'], resolve),
              meta: {
                title: '软件产品丨智慧医院居家护理系统',
                description: '海南华德科技有限公司传染病大数据分析决策平台：面向医疗机构的软件产品。',
                keywords: '互联网医院,居家护理,智慧医疗'
              }
            },
            {
              path: '/software/software7',
              name: 'software',
              component: resolve => require(['@/view/software7'], resolve),
              meta: {
                title: '软件产品丨新冠疫情防控平台',
                description: '海南华德科技有限公司新冠疫情防控平台：面向医疗机构的软件产品。',
                keywords: '新冠疫情防控,传染病预警,公共卫生'
              }
            },
            {
              path: '/software/software8',
              name: 'software',
              component: resolve => require(['@/view/software8'], resolve),
              meta: {
                title: '软件产品丨传染病直报系统',
                description: '海南华德科技有限公司传染病直报系统：面向医疗机构的软件产品。',
                keywords: '传染病直报,传染病预警,公共卫生'
              }
            },
            {
              path: '/software/software9',
              name: 'software',
              component: resolve => require(['@/view/software9'], resolve),
              meta: {
                title: '软件产品丨实验室管理系统',
                description: '海南华德科技有限公司实验室管理系统：面向医疗机构的软件产品。',
                keywords: '实验室管理,传染病检验,医疗信息化'
              }
            },
            {
              path: '/software/software10',
              name: 'software',
              component: resolve => require(['@/view/software10'], resolve),
              meta: {
                title: '软件产品丨应急处理系统',
                description: '海南华德科技有限公司应急处理系统：覆盖应急保障、监测预警、事件上报与处置全流程，支持与国家及省级疾控平台数据交换，实现“平战结合”。',
                keywords: '应急处理,突发公共卫生事件,监测预警,疾控平台,医疗信息化,海南华德科技有限公司'
              }
            },
            {
              path: '/software/software11',
              name: 'software',
              component: resolve => require(['@/view/software11'], resolve),
              meta: {
                title: '软件产品丨就医服务投诉管理系统',
                description: '海南华德科技有限公司医院满意度调查系统：以数字化手段采集患者评价，构建“评价采集-数据分析-问题改进”闭环，助力医院服务质量持续提升。',
                keywords: '医院满意度调查,患者评价,医疗服务质量,医疗健康,海南华德科技有限公司'
              }
            },
            {
              path: '/software/software12',
              name: 'software',
              component: resolve => require(['@/view/software12'], resolve),
              meta: {
                title: '软件产品丨就医服务满意度管理系统',
                description: '海南华德科技有限公司医院满意度调查管理系统：支持问卷定制、扫码评价、统计分析、问题追踪，实现患者满意度全流程数字化管理。',
                keywords: '满意度调查管理,问卷管理,患者满意度,医疗健康,海南华德科技有限公司'
              }
            },
            {
              path: '/software/software13',
              name: 'software',
              component: resolve => require(['@/view/software13'], resolve),
              meta: {
                title: '软件产品丨数字医工医疗设备管理系统',
                description: '海南华德科技有限公司数字医工医疗设备管理系统：覆盖设备采购、档案、盘点、共享、维修、质控全流程，提升设备利用率与安全管理水平。',
                keywords: '医疗设备管理,设备全生命周期,设备维修,医疗资产,海南华德科技有限公司'
              }
            },
            {
              path: '/software/software14',
              name: 'software',
              component: resolve => require(['@/view/software14'], resolve),
              meta: {
                title: '软件产品丨应急处理系统',
                description: '海南华德科技有限公司应急处理系统：覆盖应急保障、监测预警、事件上报与处置全流程，支持与国家及省级疾控平台数据交换，实现“平战结合”。',
                keywords: '应急处理,突发公共卫生事件,监测预警,疾控平台,医疗信息化,海南华德科技有限公司'
              }
            },
            {
              path: '/software/software15',
              name: 'software',
              component: resolve => require(['@/view/software15'], resolve),
              meta: {
                title: '软件产品丨数字医工医疗设备运营系统',
                description: '海南华德科技有限公司数字医工医疗设备运营系统：核算设备开机率、机时利用率与投资回报率，对接院内系统自动生成效益分析报告。',
                keywords: '设备效益分析,投资回报率,单机效益,医疗设备管理,海南华德科技有限公司'
              }
            },
            {
              path: '/software/software16',
              name: 'software',
              component: resolve => require(['@/view/software16'], resolve),
              meta: {
                title: '软件产品丨应急处理系统',
                description: '海南华德科技有限公司应急处理系统：覆盖应急保障、监测预警、事件上报与处置全流程，支持与国家及省级疾控平台数据交换，实现“平战结合”。',
                keywords: '应急处理,突发公共卫生事件,监测预警,疾控平台,医疗信息化,海南华德科技有限公司'
              }
            }
          ]
        }, {
          path: '/softwareWs',
          name: 'softwareWs',
          component: resolve => require(['@/view/softwareWs'], resolve),
          meta: {
            title: '软件产品',
            description: '海南华德科技有限公司公卫软件：疾控实验室管理、传染病智能流调、智慧托育等公共卫生产品。',
            keywords: '海南华德科技有限公司,行业数字化解决方案,互联网医院,智慧就医,医疗设备全生命周期管理,电子政务信息化,数字企业,自主软件产品'
          },
          children: [
            {
              path: '/softwareWs',
              redirect: '/software/softwareWs1'
            },
            {
              path: '/software/softwareWs1',
              name: 'softwareWs1',
              component: resolve => require(['@/view/softwareWs1'], resolve),
              meta: {
                title: '软件产品丨全员人口信息管理系统',
                description: '海南华德科技有限公司全员人口信息管理系统：建设省级全员人口基础数据库，汇聚公安、卫健、医保、民政等多源数据，提供人口主索引、全生命周期档案与人口动态监测分析。',
                keywords: '全员人口,人口信息管理,人口基础数据库,人口监测分析,电子政务,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs2',
              name: 'softwareWs2',
              component: resolve => require(['@/view/softwareWs2'], resolve),
              meta: {
                title: '软件产品丨生育服务登记管理系统',
                description: '海南华德科技有限公司生育服务登记管理系统：支持一孩二孩三孩在线登记、分级审核审批、电子签章出件与跨省通办，并提供出生人口监测与政策落实分析。',
                keywords: '生育服务登记,生育登记系统,再生育审批,跨省通办,出生人口监测,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs3',
              name: 'softwareWs3',
              component: resolve => require(['@/view/softwareWs3'], resolve),
              meta: {
                title: '软件产品丨电子死亡证明管理系统',
                description: '海南华德科技有限公司电子死亡证明管理系统：涵盖死亡医学证明签发、村居发证、公安核查与司法证明四大子系统，构建省级死亡人口信息数据中心，实现跨部门共享互认。',
                keywords: '电子死亡证明,死亡医学证明,死亡人口信息,跨部门共享,公安核查,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs4',
              name: 'softwareWs4',
              component: resolve => require(['@/view/softwareWs4'], resolve),
              meta: {
                title: '软件产品丨农村厕所革命信息系统',
                description: '海南华德科技有限公司农村厕所革命信息系统：围绕改厕建管用全流程，提供一户一档、施工留痕、验收兑付、粪污清掏调度与五级联动态势看板。',
                keywords: '农村厕所革命,改厕信息系统,一户一档,人居环境整治,长效管护,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs5',
              name: 'softwareWs5',
              component: resolve => require(['@/view/softwareWs5'], resolve),
              meta: {
                title: '软件产品丨数字化开发管控平台',
                description: '海南华德科技有限公司数字化开发管控平台：融合 DataOps 理念，提供一站式数据研发与治理能力，实现数据从需求到交付的全生命周期管理。',
                keywords: '数字化开发管控平台,DataOps,数据治理,数据研发,全生命周期管理,海南华德科技有限公司'
              }
            }

            ,{
              path: '/software/softwareWs6',
              name: 'softwareWs6',
              component: resolve => require(['@/view/softwareWs6'], resolve),
              meta: {
                title: '软件产品丨疾控智慧实验室管理系统',
                description: '海南华德科技有限公司疾控智慧实验室管理系统：覆盖样品受理流转、检验报告编制审批、人员设备试剂与标准物质管理，构建实验室全面质量监控体系。',
                keywords: '疾控实验室,实验室管理系统,检验检测,样品管理,质量管理,海南华德科技有限公司'
              }
            }
            ,{
              path: '/software/softwareWs7',
              name: 'softwareWs7',
              component: resolve => require(['@/view/softwareWs7'], resolve),
              meta: {
                title: '软件产品丨应急物资动态管理系统',
                description: '海南华德科技有限公司应急物资动态管理系统：覆盖物资采储调用补全生命周期，提供多仓管理、库存预警、应急调拨与全程追溯。',
                keywords: '应急物资,物资管理系统,应急调拨,库存预警,GIS调度,海南华德科技有限公司'
              }
            }
            ,{
              path: '/software/softwareWs8',
              name: 'softwareWs8',
              component: resolve => require(['@/view/softwareWs8'], resolve),
              meta: {
                title: '软件产品丨传染病智能流调系统',
                description: '海南华德科技有限公司传染病智能流调系统：融合多源数据辅助流行病学调查，自动绘制传播链、判定密接与风险场所，支持跨区域协查与报告自动生成。',
                keywords: '传染病流调,流行病学调查,传播链分析,密接判定,跨区域协查,海南华德科技有限公司'
              }
            }
            ,{
              path: '/software/softwareWs9',
              name: 'softwareWs9',
              component: resolve => require(['@/view/softwareWs9'], resolve),
              meta: {
                title: '软件产品丨重大事故隐患排查整治系统',
                description: '海南华德科技有限公司重大事故隐患排查整治系统：建立隐患排查登记、评估整改、验收销号闭环机制，落实企业主体责任与部门监管责任。',
                keywords: '隐患排查,隐患整治,安全生产,一企一档,风险分级管控,海南华德科技有限公司'
              }
            }
            ,{
              path: '/software/softwareWs10',
              name: 'softwareWs10',
              component: resolve => require(['@/view/softwareWs10'], resolve),
              meta: {
                title: '软件产品丨全域旅游智慧系统',
                description: '海南华德科技有限公司全域旅游智慧系统：整合吃住行游购娱全要素，提供智慧服务、智慧管理与智慧营销三大体系，助力文旅产业高质量发展。',
                keywords: '全域旅游,智慧旅游,客流监测,文旅大数据,游客画像,海南华德科技有限公司'
              }
            }
            ,{
              path: '/software/softwareWs11',
              name: 'softwareWs11',
              component: resolve => require(['@/view/softwareWs11'], resolve),
              meta: {
                title: '软件产品丨互联网舆情管理系统',
                description: '海南华德科技有限公司互联网舆情管理系统：全网信息监测、智能研判、分级预警与协同处置，支撑舆情发现研判处置反馈闭环管理。',
                keywords: '舆情监测,舆情管理,情感分析,传播溯源,预警处置,海南华德科技有限公司'
              }
            }
            ,{
              path: '/software/softwareWs12',
              name: 'softwareWs12',
              component: resolve => require(['@/view/softwareWs12'], resolve),
              meta: {
                title: '软件产品丨电子处方流转管理系统',
                description: '海南华德科技有限公司电子处方流转管理系统：打通医院 HIS 与定点零售药店，实现处方审方流转、药品调配、医保结算与全程追溯。',
                keywords: '处方流转,电子处方,院外购药,医保结算,合理用药,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs13',
              name: 'softwareWs13',
              component: resolve => require(['@/view/softwareWs13'], resolve),
              meta: {
                title: '软件产品丨新质餐厅智能识别支付系统',
                description: '海南华德科技有限公司新质餐厅智能识别支付系统：AI 视觉识别餐盘与菜品自动计价，支持刷脸支付、一卡通与企业补贴，并提供客流备餐分析与营养核算。',
                keywords: '智慧餐厅,餐盘识别,刷脸支付,食堂结算,营养分析,数字企业,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs14',
              name: 'softwareWs14',
              component: resolve => require(['@/view/softwareWs14'], resolve),
              meta: {
                title: '软件产品丨新质企业智能问数系统',
                description: '海南华德科技有限公司新质企业智能问数系统：以指标中心为底座，支持自然语言问数、多轮追问、自动制图、异常归因与报告自动推送。',
                keywords: '智能问数,对话式数据分析,指标中心,经营驾驶舱,报表自动生成,数字企业,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs15',
              name: 'softwareWs15',
              component: resolve => require(['@/view/softwareWs15'], resolve),
              meta: {
                title: '软件产品丨免税品离岛提货跟踪服务系统',
                description: '海南华德科技有限公司免税品离岛提货跟踪服务系统：服务海南自由贸易港离岛免税购物场景，打通免税销售、海关监管与提货点作业，实现线上预订、资格核验、海关验放、预约提货与扫码签收全流程数字化闭环。',
                keywords: '离岛免税,免税提货,提货跟踪,资格核验,预约提货,海关验放,三单对账,数字企业,海南华德科技有限公司'
              }
            },
            {
              path: '/software/softwareWs16',
              name: 'softwareWs16',
              component: resolve => require(['@/view/softwareWs16'], resolve),
              meta: {
                title: '软件产品丨充换电一张网服务平台',
                description: '海南华德科技有限公司充换电一张网服务平台：以数据中台为核心，构建综合监管与运营服务双翼，实现城市充换电资源一张图、监管一条链、服务一站式。',
                keywords: '充换电一张网,充电桩监管,换电服务,运营服务,数据中台,数字企业,海南华德科技有限公司'
              }
            }
          ]
        }, {
          path: '/Solution',
          name: 'Solution',
          component: resolve => require(['@/view/Solution'], resolve),
          meta: {
            title: '解决方案',
            description: '海南华德科技有限公司解决方案中心：覆盖医疗健康、公共卫生、政务服务与数字城市的整体解决方案。',
            keywords: '解决方案,医疗健康,公共卫生,数字城市,海南华德科技有限公司',
          },
          children: [
            {
              path: '/Solution',
              redirect: '/Solution/Solution1'
            },
            {
              path: '/Solution/Solution1',
              name: 'Solution1',
              component: resolve => require(['@/view/Solution1'], resolve),
              meta: {
                title: '医疗服务新质服务模型_智能一站式就诊_全程陪诊_海南华德科技有限公司',
                description: '针对医疗数据要素沉睡、服务效率低下、服务边界受限三大痛点，以新质服务模型重构就医全流程：智能一站式就诊、全程陪诊、预防+主动健康+康复护理、分级诊疗与院内外双向导流。',
                keywords: '医疗服务新质服务模型,智能一站式就诊,全程陪诊,慢病健康管理,术后康复护理,分级诊疗,双向转诊,医联体,互联网医院,医疗健康'
              }
            },
            {
              path: '/Solution/Solution2',
              name: 'Solution2',
              component: resolve => require(['@/view/Solution2'], resolve),
              meta: {
                title: '解决方案丨医疗大数据集成平台',
                description: '海南华德科技有限公司医疗大数据集成平台：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,医疗大数据集成平台',
              }
            },
            {
              path: '/Solution/Solution3',
              name: 'Solution3',
              component: resolve => require(['@/view/Solution3'], resolve),
              meta: {
                title: '解决方案丨电子病历智能检索系统',
                description: '海南华德科技有限公司电子病历智能检索系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,电子病历智能检索系统',
              }
            },
            {
              path: '/Solution/Solution4',
              name: 'Solution4',
              component: resolve => require(['@/view/Solution4'], resolve),
              meta: {
                title: '解决方案丨胸痛中心解决方案',
                description: '海南华德科技有限公司胸痛中心解决方案：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,胸痛中心解决方案',
              }
            },
            {
              path: '/Solution/Solution5',
              name: 'Solution5',
              component: resolve => require(['@/view/Solution5'], resolve),
              meta: {
                title: '解决方案丨疾控大数据集成平台',
                description: '海南华德科技有限公司疾控大数据集成平台：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,疾控大数据集成平台',
              }
            },
            {
              path: '/Solution/Solution6',
              name: 'Solution6',
              component: resolve => require(['@/view/Solution6'], resolve),
              meta: {
                title: '解决方案丨流行病调查系统',
                description: '海南华德科技有限公司流行病调查系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,流行病调查系统',
              }
            },
            {
              path: '/Solution/Solution7',
              name: 'Solution7',
              component: resolve => require(['@/view/Solution7'], resolve),
              meta: {
                title: '解决方案丨慢病一体化管理系统',
                description: '海南华德科技有限公司慢病一体化管理系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,慢病一体化管理系统',
              }
            },
            {
              path: '/Solution/Solution8',
              name: 'Solution8',
              component: resolve => require(['@/view/Solution8'], resolve),
              meta: {
                title: '解决方案丨人口信息管理系统',
                description: '海南华德科技有限公司人口信息管理系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,人口信息管理系统',
              }
            },
            {
              path: '/Solution/Solution9',
              name: 'Solution9',
              component: resolve => require(['@/view/Solution9'], resolve),
              meta: {
                title: '解决方案丨死亡信息管理系统',
                description: '海南华德科技有限公司死亡信息管理系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,死亡信息管理系统',
              }
            },
            {
              path: '/Solution/Solution10',
              name: 'Solution10',
              component: resolve => require(['@/view/Solution10'], resolve),
              meta: {
                title: '解决方案丨厕所革命信息系统',
                description: '海南华德科技有限公司厕所革命信息系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,厕所革命信息系统',
              }
            },
            {
              path: '/Solution/Solution11',
              name: 'Solution11',
              component: resolve => require(['@/view/Solution11'], resolve),
              meta: {
                title: '解决方案丨全域旅游信息系统',
                description: '海南华德科技有限公司全域旅游信息系统：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,全域旅游信息系统',
              }
            },
            {
              path: '/Solution/Solution12',
              name: 'Solution12',
              component: resolve => require(['@/view/Solution12'], resolve),
              meta: {
                title: '解决方案丨数字教育综合解决方案',
                description: '海南华德科技有限公司数字教育综合解决方案：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,数字教育综合解决方案',
              }
            },
            {
              path: '/Solution/Solution13',
              name: 'Solution13',
              component: resolve => require(['@/view/Solution13'], resolve),
              meta: {
                title: '解决方案丨数字城市综合解决方案',
                description: '海南华德科技有限公司数字城市综合解决方案：针对医疗健康与公共卫生场景的整体解决方案。',
                keywords: '医疗解决方案,医疗健康,公共卫生,数字城市综合解决方案',
              }
            }
          ]
        }, {
          path: '/advantage',
          name: 'advantage',
          component: resolve => require(['@/view/advantage'], resolve),
          meta: {
            title: '公司优势',
            description: '海南华德科技有限公司核心优势与服务能力：多年医疗信息化行业积淀、多省份落地案例、全周期交付与运维支持。',
            keywords: '公司优势,医疗信息化,服务交付,海南华德科技有限公司',
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '荣誉资质',
            description: '海南华德科技有限公司荣誉资质：企业资质、行业认证与客户认可，彰显医疗信息化领域综合实力。',
            keywords: '荣誉资质,企业认证,医疗信息化,海南华德科技有限公司',
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '海南华德科技有限公司简介',
            description: '海南华德科技有限公司（简称华德科技）简介：国家级高新技术企业，总部位于海口，拥有50余个软件著作权，聚焦医疗健康、电子政务、数字企业与互联网医院四大领域，提供医疗健康、互联网医院、集成平台等软件产品与解决方案。',
            keywords: '公司介绍,海南华德科技有限公司,医疗信息化,医疗健康,电子政务,数字企业',
          }
        }, {
          path: '/myDevelop',
          name: 'myDevelop',
          component: resolve => require(['@/view/myDevelop'], resolve),
          meta: {
            title: '海南华德科技有限公司动态 - 发展历程',
            description: '海南华德科技有限公司动态与发展历程：自2014年成立以来，先后荣获国家高新技术企业、国家级科技型中小企业、海南省软件企业、创新型中小企业与高新技术种子企业等认证，并与重庆信科设计、日向科技、琼台师范学院、海南省人民医院等建立战略合作。',
            keywords: '公司动态,发展历程,海南华德科技有限公司,高新技术企业,科技型中小企业,软件企业,战略合作',
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '合作案例',
            description: '海南华德科技有限公司合作案例：覆盖医疗健康、公共卫生、政务服务等领域的标杆项目与实践经验。',
            keywords: '合作案例,标杆项目,医疗信息化,海南华德科技有限公司',
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们',
            description: '海南华德科技有限公司联系方式：欢迎垂询医疗信息化产品与解决方案，获取项目资料与技术支持。',
            keywords: '联系我们,联系方式,海南华德科技有限公司,医疗信息化',
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '公司优势',
            description: '海南华德科技有限公司核心优势与服务能力：多年医疗信息化行业积淀、多省份落地案例、全周期交付与运维支持。',
            keywords: '公司优势,医疗信息化,服务交付,海南华德科技有限公司',
          }
        },
        {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/news'], resolve),
          meta: {
            title: '解决方案',
            description: '海南华德科技有限公司行业资讯：医疗健康、公共卫生与数字医疗政策动态与解读。',
            keywords: '行业资讯,医疗政策,海南华德科技有限公司',
          },
          children: [
            {
              path: '/news',
              redirect: '/news/news1'
            },
            {
              path: '/news/news1',
              name: 'news1',
              component: resolve => require(['@/view/news1'], resolve),
              meta: {
                title: '国务院办公厅关于印发“十四五”国民健康规划的通知',
                description: '海南华德科技有限公司行业资讯：国务院办公厅关于印发“十四五”国民健康规划的通知。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,国务院办公厅关于印发“十四五”国民健康规划的通知',
              }
            },
            {
              path: '/news/news2',
              name: 'news2',
              component: resolve => require(['@/view/news2'], resolve),
              meta: {
                title: '关于印发医疗机构检查检验结果互认管理办法的通知',
                description: '海南华德科技有限公司行业资讯：关于印发医疗机构检查检验结果互认管理办法的通知。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,关于印发医疗机构检查检验结果互认管理办法的通知',
              }
            },
            {
              path: '/news/news3',
              name: 'news3',
              component: resolve => require(['@/view/news3'], resolve),
              meta: {
                title: '三级医院评审标准（2020年版）',
                description: '海南华德科技有限公司行业资讯：三级医院评审标准（2020年版）。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,三级医院评审标准（2020年版）',
              }
            },
            {
              path: '/news/news4',
              name: 'news4',
              component: resolve => require(['@/view/news4'], resolve),
              meta: {
                title: '海南自由贸易港建设总体方案',
                description: '海南华德科技有限公司行业资讯：海南自由贸易港建设总体方案。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,海南自由贸易港建设总体方案',
              }
            },
            {
              path: '/news/news5',
              name: 'news5',
              component: resolve => require(['@/view/news5'], resolve),
              meta: {
                title: '国家卫生健康委办公厅关于做好信息化支撑常态化疫情防控工作的通知',
                description: '海南华德科技有限公司行业资讯：国家卫生健康委办公厅关于做好信息化支撑常态化疫情防控工作的通知。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,国家卫生健康委办公厅关于做好信息化支撑常态化疫情防控工作的通知',
              }
            },
            {
              path: '/news/news6',
              name: 'news6',
              component: resolve => require(['@/view/news6'], resolve),
              meta: {
                title: '医院智慧服务分级评估标准体系（试行）',
                description: '海南华德科技有限公司行业资讯：医院智慧服务分级评估标准体系（试行）。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,医院智慧服务分级评估标准体系（试行）',
              }
            },
            {
              path: '/news/news7',
              name: 'news7',
              component: resolve => require(['@/view/news7'], resolve),
              meta: {
                title: '关于支持博鳌乐城国际医疗旅游先行区发展的措施(试行)',
                description: '海南华德科技有限公司行业资讯：关于支持博鳌乐城国际医疗旅游先行区发展的措施(试行)。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,关于支持博鳌乐城国际医疗旅游先行区发展的措施(试行)',
              }
            },
            {
              path: '/news/news8',
              name: 'news8',
              component: resolve => require(['@/view/news8'], resolve),
              meta: {
                title: '医院智慧管理分级评估标准体系（试行）',
                description: '海南华德科技有限公司行业资讯：医院智慧管理分级评估标准体系（试行）。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,医院智慧管理分级评估标准体系（试行）',
              }
            },
            {
              path: '/news/news9',
              name: 'news9',
              component: resolve => require(['@/view/news9'], resolve),
              meta: {
                title: '国家三级公立医院绩效考核操作手册(2022 版)',
                description: '海南华德科技有限公司行业资讯：国家三级公立医院绩效考核操作手册(2022 版)。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,国家三级公立医院绩效考核操作手册(2022 版)',
              }
            },
            {
              path: '/news/news10',
              name: 'news10',
              component: resolve => require(['@/view/news10'], resolve),
              meta: {
                title: '海南省加快推进数字疗法产业发展的若干措施',
                description: '海南华德科技有限公司行业资讯：海南省加快推进数字疗法产业发展的若干措施。聚焦医疗健康、公共卫生与数字医疗政策动态。',
                keywords: '医疗政策,行业资讯,海南省加快推进数字疗法产业发展的若干措施',
              }
            },
          ]
        },
      ]
    },

    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',

      component: resolve => require(['@/view/PrivacyPolicy'], resolve),
      meta: {
        title: '隐私政策',
        description: '海南华德科技有限公司隐私政策：说明我们如何收集、使用与保护您的个人信息。',
        keywords: '隐私政策,个人信息保护,海南华德科技有限公司',
      }
    },
    {
      path: '/privacyAct',
      name: 'privacyAct',

      component: resolve => require(['@/view/privacyAct'], resolve),
      meta: {
        title: '用户服务协议',
        description: '海南华德科技有限公司用户服务协议：约定平台服务的使用条款与双方权利义务。',
        keywords: '用户服务协议,服务条款,海南华德科技有限公司',
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js